__turbopack_context__.v({
  "digestBody": "X1_8rW_digestBody",
  "digestBtn": "X1_8rW_digestBtn",
  "digestCard": "X1_8rW_digestCard",
  "digestTitle": "X1_8rW_digestTitle",
  "iconBadge": "X1_8rW_iconBadge",
  "manageLink": "X1_8rW_manageLink",
  "rail": "X1_8rW_rail",
  "railCard": "X1_8rW_railCard",
  "railInfo": "X1_8rW_railInfo",
  "railLogo": "X1_8rW_railLogo",
  "railLogoFallback": "X1_8rW_railLogoFallback",
  "railName": "X1_8rW_railName",
  "railNameRow": "X1_8rW_railNameRow",
  "railReason": "X1_8rW_railReason",
  "railRow": "X1_8rW_railRow",
  "railSkeletonBlock": "X1_8rW_railSkeletonBlock",
  "railSkeletonRow": "X1_8rW_railSkeletonRow",
  "railStory": "X1_8rW_railStory",
  "railStoryTitle": "X1_8rW_railStoryTitle",
  "railTitle": "X1_8rW_railTitle",
  "subscribedCard": "X1_8rW_subscribedCard",
  "whyBody": "X1_8rW_whyBody",
  "whyTitle": "X1_8rW_whyTitle",
});
